export default __webpack_public_path__ + "static/media/destin2.944d6851.jpg";